// extracted by mini-css-extract-plugin
module.exports = {"forgot":"Login_forgot__1Mc9C","spinner":"Login_spinner__C93oh","shake-horizontal":"Login_shake-horizontal__3nyQa","grow":"Login_grow__1B_Jp"};